import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import Modal from '../../UniformComponents/Modal'
import ModalHeader from '../../UniformComponents/ModalHeader'
import ModalFooter from '../../UniformComponents/ModalFooter'
import Button from '../../UniformComponents/Button'
import Typography from '../../UniformComponents/Typography'

@observer
class TemplateCloneModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const {
            show, onClose, dashStore,
        } = this.props
        const { saveDashboard, duplicateDashFromTemplate } = dashStore

        return (
            <Modal show={show} onClose={onClose}>
                <ModalHeader>
                    <h2 style={{ width: '100%', textAlign: 'center' }}>
                        {i18n.t('dashboards.modal.templateClone.title')}
                    </h2>
                </ModalHeader>

                <div style={{
                    width: '100%', textAlign: 'center',
                }}
                >
                    <Typography>{i18n.t('dashboards.modal.templateClone.desc.1')}</Typography>

                    <br />

                    <Typography>{i18n.t('dashboards.modal.templateClone.desc.2')}</Typography>

                    <br />

                    <Typography>{i18n.t('dashboards.modal.templateClone.desc.3')}</Typography>
                </div>

                <ModalFooter>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-around' }}>
                        <Button cssClass="regular primary" onClick={() => duplicateDashFromTemplate()}>
                            {i18n.t('dashboards.modal.templateClone.button.clone')}
                        </Button>

                        <Button cssClass="regular primary" onClick={() => saveDashboard()}>
                            {i18n.t('dashboards.modal.templateClone.button.save')}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default TemplateCloneModal
